import GetSubscriptionContractRequestModelBase from '../_generated/modelBases/get-subscription-contract-request-model-base';

export default class GetSubscriptionContractRequestModel extends GetSubscriptionContractRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
